import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { links, constants, compose } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'
import resolvePostponed from 'decorators/resolvePostponed'

import NewSubscriptionThankYouPage from './NewSubscriptionThankYouPage/NewSubscriptionThankYouPage'
import ThankYouPageContent from './ThankYouPageContent/ThankYouPageContent'
import NewThankYouPageFromNewPaymentFlow from './NewThankYouPageFromNewPaymentFlow/NewThankYouPageFromNewPaymentFlow'

import Analytics from './Analytics/Analytics'


class ThankYouPage extends Component {

  static propTypes = {
    gender: PropTypes.oneOf([ 'male', 'female' ]),
    billingPeriod: PropTypes.number,
    hasItemInQueue: PropTypes.bool,
    redirectLink: PropTypes.string,
  }

  componentWillMount() {
    const { redirect, redirectLink, paymentData } = this.props

    if (!paymentData) {
      redirect(redirectLink)
    }
  }

  componentDidMount() {
    const { paymentData } = this.props

    if (!paymentData) {
      // Block logic if redirect in componentWillMount (client side)
      return
    }

    // TODO rework this when old payment page will be removed

    const setSubscribedCookie = (
      paymentData.paymentType && paymentData.paymentType.includes(constants.paymentTypes.subscription)
    )

    if (setSubscribedCookie) {
      actions.misc.cookies.setSessionItem(constants.cookieNames.isJustSubscribed, true)
    }

    actions.misc.cookies.removeItem(constants.cookieNames.offer)
    actions.misc.cookies.removeItem(constants.cookieNames.bindedCoupon)
    actions.misc.cookies.removeItem(constants.cookieNames.discountCoupon)
    actions.misc.cookies.removeItem(constants.cookieNames.isFreeTrialOrgFlow)
    actions.models.payment.setIsFacebookMixLandingCampaign(false)

    actions.misc.cookies.removeItem(constants.cookieNames.isFacebookFlowEnabled)
    actions.misc.cookies.removeItem(constants.cookieNames.specialFlowName)
    actions.misc.cookies.removeItem(constants.cookieNames.makeupIntroFlow)
    actions.misc.cookies.removeItem(constants.cookieNames.selectedPlan)
    // cookies set on PaymentForm.js line 278
    actions.misc.cookies.removeItem(constants.cookieNames.shippingFields)
  }

  componentWillUnmount() {
    actions.view.thankYouPage.resetPaymentData()
  }

  render() {
    const { paymentData } = this.props

    if (!paymentData) {
      // Block logic if redirect in componentWillMount (client side)
      return null
    }

    const {
      billingPeriod, gender, hasItemInQueue, redirectLink, isUpgradable,
      isNewThankYouPageFromNewPaymentFlowEnabled, isInviteFriendSectionEnabled,
    } = this.props
    const { paymentType, hasLockedProductsAfterSubscription } = paymentData

    const isSubscription = paymentType && paymentType.includes(constants.paymentTypes.subscription)

    const commonPageProps = {
      billingPeriod,
      gender,
      redirectLink,
      isUpgradable,
      hasItemInQueue,
      isInviteFriendSectionEnabled,
      hasLockedProductsAfterSubscription,
    }

    return (
      <Fragment>
        <Analytics data={paymentData} />
        {
          isSubscription ? (
            isNewThankYouPageFromNewPaymentFlowEnabled ? (
              <NewThankYouPageFromNewPaymentFlow {...commonPageProps} />
            ) : (
              <NewSubscriptionThankYouPage {...commonPageProps} />
            )
          ) : (
            <ThankYouPageContent isSubscription={isSubscription} data={paymentData} {...commonPageProps} />
          )
        }
      </Fragment>
    )
  }
}


export default compose(
  resolvePostponed(),
  injectGlobals(({ getAbValue, getCookieValue, redirect }) => ({
    redirect,
    offer: getCookieValue(constants.cookieNames.offer),
    discountCoupon: getCookieValue(constants.cookieNames.discountCoupon),
    bindedCoupon: getCookieValue(constants.cookieNames.bindedCoupon) || {},
    isProductQuizEnabled: getAbValue(constants.abTests.productQuiz) === 'b',
    isMakeupIntroFlowEnabled: Boolean(getCookieValue(constants.cookieNames.makeupIntroFlow)),
    isInviteFriendSectionEnabled: getAbValue(constants.abTests.inviteFriendThankYouPage) === 'b',
    isNewThankYouPageFromNewPaymentFlowEnabled: getAbValue(constants.abTests.newMobileThankYouPage) === 'b',
  })),
  connect({
    gender: 'models.me.gender',
    isUpgradable: 'models.subscription.isUpgradable',
    billingPeriod: 'models.subscription.currPlan.billingPeriod',
    paymentData: (state, { offer, bindedCoupon, discountCoupon }) => {
      const { paymentData } = state.view.thankYouPage

      if (paymentData) {
        paymentData.offer       = offer
        paymentData.couponType  = bindedCoupon.couponType
        paymentData.couponCode  = paymentData.couponCode || bindedCoupon.code || discountCoupon

        return paymentData
      }

      return null
    },
    hasItemInQueue: (state) => {
      const { models: { queue: { items } } } = state

      return Boolean(items[0] && !items[0].empty)
    },
    redirectLink: (state, props) => {
      const { models: { me: { gender } } } = state
      const { isProductQuizEnabled, isMakeupIntroFlowEnabled, data = {} } = props

      const isSubscription = data.paymentType && data.paymentType.includes(constants.paymentTypes.subscription)

      let link = gender === 'male' ? links.subscription.colognes : links.subscription.perfumes

      if (isMakeupIntroFlowEnabled && isSubscription) {
        link = links.makeup
      }
      else if (isProductQuizEnabled) {
        link = links.quizProduct
      }

      return link
    },
  }),
)(ThankYouPage)
